import { useEffect, useState } from 'react';
import { listRelationRoles } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useRelationRole(practice_area = '', loadFullList = true, limit = 15, isLandingPage = false) {
  const [List, setList] = useState([]);
  const [nextToken, setNextToken] = useState('');

  const loadRelationRoles = async () => {
    let pageLimit = limit;
    if (loadFullList) {
      const response = await totalCountEvent('relation_role');
      pageLimit = response?.data;
    }
    try {
      const response = await listRelationRoles(pageLimit, '', '', 'alphabet_ascending', practice_area, true);
      setList(response?.data?.relation_role);
      setNextToken(response?.data?.next_token || '');
      return response?.data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadRelationRoles();
  }, [practice_area]);

  return { relationRoleList: List };
}
